import createStore from '../store/index'

const reduxStore = createStore()

export default reduxStore
